import React, {Component} from 'react';
import {connect} from 'react-redux';
import {changeSinglePuzzle, handleDraggedPuzzles, findAllMoved} from '../state/puzzlesOnBoard';
import {updateBoard} from '../state/sheets';
import {hideRightMenu} from '../state/expandRightMenu';
import {setActiveButton} from '../state/activeButton';
import {showClearAlert} from '../state/showClearAlert';
import {clearPuzzles} from "../state/puzzlesOnBoard";
import AlertWindow from './AlertWindow';
import ActionsBar from "./ActionsBar";
import {Alert} from "react-bootstrap";
import {LanguageContext} from "../App";
import CustomMenu from "./CustomMenu";
import {
    OzobotStart,
    PauseIcon,
    PlayIcon, PowerOffIcon,
    RotateIcon,
    SimulatorBar,
    SimulatorButton
} from "../Simulator/SimulatorStyles";
import {showAlert} from "../state/showAlert";

class WorkingSpace extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showClearAlert: false,
            showNoPuzzleAlert: false,
            keyCode: '',
            scalesIndex: 5,
            imgSize: 210,
            posX: 0,
            posY: 0,
            draggingPuzzle: false,
            draggedPuzzle: {},
            draggingBoard: false,
            startingCords: {
                x: 0,
                y: 0,
            },
            cameraTracking: false,
            centerOnStart: false,
        };

        this.scales = [0.1, 0.2, 0.4, 0.6, 0.8, 1, 1.2, 1.4, 1.6, 1.8, 2];
        this.puzzlesPerRowAndColumn = 100;

        this.drawDragGhost = (e, language) => {
            let allMovedPuzzles = findAllMoved([], this.props.puzzlesOnBoard.present, this.state.draggedPuzzle, this.state.keyCode);
            let ghostPosX;
            let ghostPosY;
            if (allMovedPuzzles.length > 1) {
                ghostPosX = Math.abs((allMovedPuzzles.sort((puzzleDim, nextPuzzleDim) => puzzleDim.x - nextPuzzleDim.x)[0].x - this.state.draggedPuzzle.x));
                ghostPosX = ghostPosX === 0 ? (this.state.imgSize * this.props.scale / 2) : ghostPosX * this.state.imgSize * this.props.scale;

                let sortY = allMovedPuzzles.sort((puzzleDim, nextPuzzleDim) => puzzleDim.y - nextPuzzleDim.y);
                ghostPosY = Math.abs((sortY[0].y - this.state.draggedPuzzle.y));
                ghostPosY = ghostPosY === 0 ? (this.state.imgSize * this.props.scale / 2) : ghostPosY * this.state.imgSize * this.props.scale;
            } else {
                ghostPosX = ghostPosY = (this.state.imgSize * this.props.scale / 2);
            }

            let ele = document.createElement('div');
            ele.id = 'dragGhost';
            ele.style.position = "absolute";
            ele.style.top = "-10000vh";
            ele.style.left = "-10000vw";

            for (let i = 0; i < allMovedPuzzles.length; i++) {
                let puzzle = allMovedPuzzles[i];
                let child = document.createElement('div');
                let cs = child.style;
                cs.width = cs.height = this.state.imgSize * this.props.scale + 'px';
                cs.backgroundImage = 'url(/akademia/image/puzzles/' + this.props.purePuzzles[allMovedPuzzles[i].id].path[language] + ')';
                cs.position = 'absolute';
                cs.top = ((puzzle.y * this.props.puzzleSize) - 27) * this.props.scale + 'px';
                cs.left = ((puzzle.x * this.props.puzzleSize) - 26) * this.props.scale + 'px';
                cs.transform = 'rotate(' + this.props.directions[puzzle.direction] + 'deg)';

                ele.appendChild(child)
            }
            document.body.appendChild(ele);
            e.dataTransfer.clearData();
            e.dataTransfer.setData('text/html', '');
            e.dataTransfer.setDragImage(ele, ghostPosX, ghostPosY);
            e.dataTransfer.effectAllowed = "move";
        };

        this.handleDragEndPuzzle = () => {
            let rect = this.props.canvas.getBoundingClientRect();
            let newX = this.countXY(this.props.dragX, rect.left);
            let newY = this.countXY(this.props.dragY, rect.top);
            document.getElementById('dragGhost').remove();

            let allMoved = findAllMoved([], this.props.puzzlesOnBoard.present, this.state.draggedPuzzle, this.state.keyCode);
            const moveX = newX - this.state.draggedPuzzle.x;
            const moveY = newY - this.state.draggedPuzzle.y;
            let newMoved = allMoved.map(puzzle => {
                return {
                    x: puzzle.x + moveX,
                    y: puzzle.y + moveY,
                    id: puzzle.id,
                    direction: puzzle.direction,
                    path: puzzle.path
                }
            });
            const outOfBorder = newMoved.find(puzzle => {
                return puzzle.x < 1 || puzzle.y < 1 || puzzle.x >= this.puzzlesPerRowAndColumn || puzzle.y >= this.puzzlesPerRowAndColumn;
            });
            if (outOfBorder) {
                return this.props.showAlert('drag-out-of-range');
            } else {
                let newPresent = this.props.puzzlesOnBoard.present.filter(puzzle => {
                    let isOverWritten = newMoved.find(newPuzzle => newPuzzle.x === puzzle.x && newPuzzle.y === puzzle.y);
                    if (!isOverWritten) {
                        return puzzle;
                    } else return null;
                });
                newPresent = newPresent.filter(puzzle => allMoved.indexOf(puzzle) === -1).concat(newMoved);
                let nextPast = this.props.puzzlesOnBoard.past;
                nextPast.push(this.props.puzzlesOnBoard.present);

                return this.props.handleDraggedPuzzles(
                    Object.assign({}, {
                        past: nextPast,
                        present: newPresent,
                        future: []
                    })
                )
            }
        };

        this.handleMouseDown = e => {
            if (this.props.isExpandedRightMenu.tab === 'eksport') {
                this.props.hideRightMenu();
                this.props.setActiveButton({name: ''});
            }
            this.setState({startingCords: {x: e.clientX, y: e.clientY}});
            if (e.target.id === 'drawing') {
                const canvas = document.querySelector('#drawing');
                canvas.onmousemove = this.handleMouseMoveOnCanvas;
                canvas.onmouseup = this.handleMouseUpAndLeaveOnCanvas;
                canvas.onmouseleave = this.handleMouseUpAndLeaveOnCanvas;
                this.props.onCanvasChanged(canvas);
            } else {
                this.setState({draggedPuzzle: e.target.dataset})
            }
        };

        this.handleMouseMoveOnCanvas = e => {
            e.preventDefault();
            if (this.state.cameraTracking && localStorage.getItem('is_ozobot_running') === '1') return;
            let diffX = Math.abs(this.state.startingCords.x - e.clientX);
            let diffY = Math.abs(this.state.startingCords.y - e.clientY);
            if (diffX > 10 || diffY > 10) {
                if (!this.state.posX || !this.state.posY) {
                    this.setState({draggingBoard: true, posX: e.clientX, posY: e.clientY});
                }
                this.checkBorders(e);
                this.setState({draggingBoard: true});
            }
        };

        this.checkBorders = (e) => {
            let posX = e.clientX - this.state.posX;
            let posY = e.clientY - this.state.posY;
            let canvas = this.props.canvas;
            const canvasContainer = this.props.canvasContainer;
            posX = posX > 0 && canvas.offsetLeft > -1 ? 0 : ((Math.abs(canvas.offsetLeft) + canvasContainer.clientWidth) > canvas.clientWidth) && posX < 0 ? 0 : posX;
            posY = posY > 0 && canvas.offsetTop > -1 ? 0 : ((Math.abs(canvas.offsetTop) + canvasContainer.clientHeight) > canvas.clientHeight) && posY < 0 ? 0 : posY;
            canvas.style.left = canvas.offsetLeft + posX + 'px';
            canvas.style.top = canvas.offsetTop + posY + 'px';
            this.props.onCanvasChanged(canvas);
            this.setState({posX: e.clientX, posY: e.clientY})
        };

        this.countXY = (clientXY, rectLeftTop) => {
            let diff = 15 * this.props.diffCounter;
            return Math.floor((clientXY - rectLeftTop + diff + (this.props.puzzleSize / 2)) / (this.props.puzzleSize * this.props.scale))
        };

        this.handleMouseUpAndLeaveOnCanvas = () => {
            const canvas = this.props.canvas;
            const canvasContainer = this.props.canvasContainer;
            canvas.style.left = canvas.offsetLeft > 0 ? 0 : ((Math.abs(canvas.offsetLeft) + canvasContainer.clientWidth) > canvas.clientWidth) ? -(canvas.clientWidth - canvasContainer.clientWidth) + 'px' : canvas.style.left;
            canvas.style.top = canvas.offsetTop > 0 ? 0 : ((Math.abs(canvas.offsetTop) + canvasContainer.clientHeight) > canvas.clientHeight) ? -(canvas.clientHeight - canvasContainer.clientHeight) + 'px' : canvas.style.top;
            canvas.onmousemove = null;
            canvas.onmouseleave = null;
            canvas.onmouseup = null;
            this.props.onCanvasChanged(canvas);
            this.setState({
                posX: 0,
                posY: 0,
            });
            if (!this.state.draggingBoard && !this.props.activePuzzle.id) {
                this.props.showAlert('null-puzzle');
            }
        };

        this.setPuzzle = e => {
            if (this.state.keyCode !== 'AltRight' && this.state.keyCode !== 'AltLeft') {
                if (!this.state.draggingBoard && Object.keys(this.props.activePuzzle).length) {
                    let rect = this.props.canvas.getBoundingClientRect();
                    let puzzlePosX = this.countXY(e.clientX, rect.left);
                    let puzzlePosY = this.countXY(e.clientY, rect.top);

                    if ((puzzlePosX >= 1 && puzzlePosX < this.puzzlesPerRowAndColumn) && (puzzlePosY >= 1 && puzzlePosY < this.puzzlesPerRowAndColumn)) {
                        this.props.changeSinglePuzzle({
                            x: puzzlePosX,
                            y: puzzlePosY,
                            id: this.props.activePuzzle.id,
                            direction: this.props.activePuzzle.direction,
                            path: this.props.purePuzzles[this.props.activePuzzle.id].path
                        }, this.puzzlesPerRowAndColumn);
                    } else {
                        this.props.showAlert('out-of-range');
                    }
                } else if (!this.state.draggingBoard) {
                    this.props.showAlert('null-puzzle');
                }
            }

            this.setState({draggingBoard: false})
        };

        this.scaleCanvas = (scalesIndex, diff) => {
            const canvas = this.props.canvas;
            const canvasContainer = this.props.canvasContainer;
            let x = ((canvas.offsetLeft - (canvasContainer.clientWidth / 2))) / canvas.clientWidth;
            let y = ((canvas.offsetTop - (canvasContainer.clientHeight / 2))) / canvas.clientHeight;
            let _scalesIndex = scalesIndex;
            if (_scalesIndex > this.scales.length - 1) {
                _scalesIndex = this.scales.length - 1
            } else if (_scalesIndex < 0) {
                _scalesIndex = 0;
            }
            const _scale = this.scales[_scalesIndex];
            const backgroundSize = this.props.puzzleSize * _scale;
            const backgroundSizeRounded = Math.round(backgroundSize);
            const backgroundPosition = (backgroundSize - backgroundSizeRounded) * 54;
            canvas.style.backgroundSize = Math.round(this.props.puzzleSize * _scale) + 'px';
            canvas.style.backgroundPositionX = backgroundPosition + 'px';
            canvas.style.backgroundPositionY = backgroundPosition + 'px';
            this.props.onCanvasChanged(canvas);
            this.setCanvasDimensions(_scale);
            this.setCanvasPosition(x, y);
            this.props.onDiffCounterChanged(diff);
            this.setState({scalesIndex: _scalesIndex});
            this.props.onScaleChanged(_scale);
        };

        this.setKeyCode = e => {
            if (document.activeElement.tagName !== 'INPUT') {
                this.setState({keyCode: e.code});
            }
        };

        this.clearKeyCode = () => {
            this.setState({keyCode: ''})
        };

        this.handleOnBoardRotation = e => {
            if (this.state.keyCode === 'AltRight' || this.state.keyCode === 'AltLeft') {
                const newDir = {'s': 'w', 'w': 'n', 'n': 'e', 'e': 's'};
                let nextPast = this.props.puzzlesOnBoard.past;
                nextPast.push(this.props.puzzlesOnBoard.present);
                let newPresent = this.props.puzzlesOnBoard.present.map(puzzle => (
                    puzzle.x === parseInt(e.target.dataset.x, 10) &&
                    puzzle.y === parseInt(e.target.dataset.y, 10)
                ) ? Object.assign({}, puzzle, {'direction': newDir[puzzle.direction]}) : puzzle);

                return this.props.handleDraggedPuzzles(
                    Object.assign({}, {
                        past: nextPast,
                        present: newPresent,
                        future: []
                    })
                )

            }
        }
    }

    setCanvasDimensions(scale) {
        const canvas = document.querySelector('#drawing');
        canvas.style.width = this.puzzlesPerRowAndColumn * this.props.puzzleSize * scale + 'px';
        canvas.style.height = this.puzzlesPerRowAndColumn * this.props.puzzleSize * scale + 'px';
        this.props.onCanvasChanged(canvas);
    }

    setCanvasPosition(x = 0, y = 0) {
        const canvas = document.querySelector('#drawing');
        const canvasContainer = document.querySelector('#workingSpaceContainer');
        const containerWidth = canvasContainer.clientWidth;
        const containerHeight = canvasContainer.clientHeight;
        let left = (canvas.clientWidth * x) + containerWidth / 2;
        let top = (canvas.clientHeight * y) + containerHeight / 2;
        if (left > 0) {
            left = 0;
        }
        if (top > 0) {
            top = 0;
        }
        canvas.style.left = left + 'px';
        canvas.style.top = top + 'px';

        this.props.onCanvasChanged(canvas);
    }

    componentDidMount() {
        let drawing = document.querySelector('#drawing');
        document.addEventListener('keydown', this.setKeyCode);
        document.addEventListener('keyup', this.clearKeyCode);
        this.setCanvasDimensions(1);
        this.setCanvasPosition();
        (function () {
            drawing.style.top = -drawing.clientHeight / 2 + 'px';
            drawing.style.left = -drawing.clientWidth / 2 + 'px';
        })();

        if (window.innerWidth <= 1100) {
            this.props.showAlert('to-small-window');
        }

        this.props.getCanvas();
    }

    componentDidUpdate(prevProps, prevState) {
        let hash = this.props.puzzlesOnBoard.hash ? this.props.puzzlesOnBoard.hash.length : 0;

        if (JSON.stringify(this.props.puzzlesOnBoard) !== JSON.stringify(prevProps.puzzlesOnBoard) && !hash) {
            let url = document.location.href.split('/');
            if (url[url.length - 1].match(new RegExp('^[a-z0-9]{8}$', 'gi'))) {
                url.splice(-1, 1);
                window.history.pushState('', '', url.join('/'));
            }
        }

        if (prevState.keyCode !== this.state.keyCode) {
            if (this.state.keyCode === 'KeyC') {
                this.setState({cameraTracking: !this.state.cameraTracking});
            }
        }

        if (prevState.centerOnStart !== this.state.centerOnStart && this.state.centerOnStart === true) {
            let {x, y} = this.props.ozobotPosition;
            this.centerView(x, y);
            this.setState({centerOnView: true})
        }

        if (localStorage.getItem('is_ozobot_running') === '1'
            && (prevProps.ozobotPosition.x !== this.props.ozobotPosition.x
                || prevProps.ozobotPosition.y !== this.props.ozobotPosition.y)
        ) {
            let {x, y} = this.props.ozobotPosition;
            const trackingMargin = 50;
            if (this.state.cameraTracking
                || (Math.abs(this.props.canvas.offsetLeft - trackingMargin) >= (x * this.props.puzzleSize * this.props.scale)
                    || Math.abs(this.props.canvas.offsetTop - trackingMargin) >= (y * this.props.puzzleSize * this.props.scale)
                    || (Math.abs(this.props.canvas.offsetLeft) + this.props.canvasContainer.offsetWidth - trackingMargin) <= (x * this.props.puzzleSize * this.props.scale)
                    || (Math.abs(this.props.canvas.offsetTop) + this.props.canvasContainer.offsetHeight - trackingMargin - 75) <= (y * this.props.puzzleSize * this.props.scale))
            ) {
                this.centerView(x, y);
            }
        }

        this.props.getCanvas();
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.setKeyCode);
        document.removeEventListener('keyup', this.clearKeyCode)
    }

    renderNoPuzzleAlert = () => this.state.showNoPuzzleAlert
            &&  <LanguageContext.Consumer>
            {({language}) =>
                <div id="alertOnClear">
                    <Alert bsStyle="warning">
                        <p style={{
                            'margin': '0 0 1.4rem 0',
                            'color': '#ffffff',
                            'fontFamily': 'Robota, sans-serif'
                        }}>{language['info_brak_puzzli']}</p>
                        <div className="d-flex flex-row justify-content-between">
                            <button id="confirmClear"
                                    className="btn text-white"
                                    onClick={() => this.setState({showNoPuzzleAlert: false})}>
                                {language['zamknij']}
                            </button>
                        </div>
                    </Alert>
                </div>
            }
        </LanguageContext.Consumer>;

    centerView = (x, y) => {
        x /= -100;
        y /= -100;
        this.setCanvasPosition(x, y);
    };

    render() {
        let clearAlert = '';
        if (this.props.showClearAlertState) {
            clearAlert = <LanguageContext.Consumer>
                {({language}) =>
                    <div id="alertOnClear">
                        <Alert bsStyle="warning">
                            <p style={{
                                'margin': '0 0 1.4rem 0',
                                'color': '#ffffff',
                                'fontFamily': 'Robota, sans-serif'
                            }}>{language['info_usun']}</p>
                            <div className="d-flex flex-row justify-content-between">
                                <button id="confirmClear" className="btn text-white" onClick={() => {
                                    this.props.clearPuzzles();
                                    this.props.onSimulatorEnd();
                                    this.props.showClearAlert("HIDE_CLEAR_ALERT");
                                }}>{language['tak']}
                                </button>
                                <button id="rejectClear" className="btn text-white"
                                        onClick={() => this.props.showClearAlert("HIDE_CLEAR_ALERT")}>{language['nie']}
                                </button>
                            </div>
                        </Alert>
                    </div>
                }
            </LanguageContext.Consumer>
        }

        let puzzlesOnBoard = this.props.puzzlesOnBoard.present.map(puzzle => {
            const getPath = (language) => "url('/akademia/image/puzzles/" + this.props.purePuzzles[puzzle.id].path[language] + "')";
            let getStyles = (language) => ({
                position: 'absolute',
                top: ((puzzle.y * this.props.puzzleSize - 26 - this.props.puzzleSize / 2) * this.props.scale) - 0.5,
                left: ((puzzle.x * this.props.puzzleSize - 26 - this.props.puzzleSize / 2) * this.props.scale) - 0.5,
                backgroundImage: getPath(language),
                width: this.state.imgSize * this.props.scale + 'px',
                height: this.state.imgSize * this.props.scale + 'px',
                transform: 'rotate(' + this.props.directions[puzzle.direction] + 'deg)',
                backgroundSize: 'contain',
            });
            return (
                <LanguageContext.Consumer>
                    {({ language }) =>
                        <div style={getStyles(language['jezyk'])} draggable
                            key={puzzle.x + '' + puzzle.y}
                            data-x={puzzle.x}
                            data-y={puzzle.y}
                            data-id={puzzle.id}
                            data-direction={puzzle.direction}
                            onClick={this.handleOnBoardRotation}
                            onDragStart={(e) => { this.drawDragGhost(e, language['jezyk']); }}
                            onDragEnd={this.handleDragEndPuzzle.bind(this)}
                            onDragOver={this.props.onPuzzleOver}
                        />}
                </LanguageContext.Consumer>);
        });

        let ozobot = this.props.renderOzobot();

        const simulatorBarRender = () => {
            let isRunning = localStorage.getItem('is_ozobot_running') === '1';
            if (this.props.isSimulatorStarted) {
                return <SimulatorBar>
                    <SimulatorButton className={"navi-button" + (isRunning ? " disabled" : "")}
                                     onClick={this.props.onRotateRight}
                                     title={isRunning ? "Zatrzymaj robota, żeby obrócić" :"Obrót robota o 90 stopni"}
                                     disabled={isRunning}>
                        <RotateIcon/>
                    </SimulatorButton>
                    {isRunning
                        ? <SimulatorButton className="navi-button" onClick={this.props.onStop} title="Robot się zatrzymuje">
                            <PauseIcon/>
                        </SimulatorButton>
                        : <SimulatorButton className="navi-button" onClick={() => {
                            this.props.onStart();
                            this.setState({centerOnStart: true})
                        }} title="Robot jedzie po trasie">
                            <PlayIcon/>
                        </SimulatorButton>
                    }
                    <SimulatorButton className="navi-button" onClick={this.props.onSimulatorEnd} title="Wyłączenie symulatora robota">
                        <PowerOffIcon/>
                    </SimulatorButton>
                </SimulatorBar>;
            } else {
                return (            
                <LanguageContext.Consumer>
                    {({ language }) =>
                        <SimulatorBar>
                                <OzobotStart onClick={() => {
                                        if (!this.props.canStartSimulator()) {
                                            this.setState({showNoPuzzleAlert: true})
                                        }
                                        this.props.onSimulatorStart();
                                        this.setState({centerOnStart: true})
                                    }}
                                    language={language['jezyk']}
                                />
                        </SimulatorBar>
                    }
                </LanguageContext.Consumer>);
            }
        };

        return (
            <LanguageContext.Consumer>
                {({ language }) =>
                    <div id="workingSpaceContainer">
                        <AlertWindow/>
                        {clearAlert}
                        {this.renderNoPuzzleAlert()}
                        <div id="drawing"
                             onDragOver={this.props.onDrawingDragOver}
                             onMouseDown={this.handleMouseDown}
                             onClick={this.setPuzzle}>
                            {puzzlesOnBoard}
                            {ozobot}
                        </div>
                        <ActionsBar>
                            {simulatorBarRender()}
                            <div className="d-flex">
                                <div id="zoomIcons" className={this.props.isExpandedRightMenu ? 'expanded-zoom-icons' : ''}>
                                    <button
                                        className={this.scales[this.state.scalesIndex] === 2 ? "navi-button inactive" : "navi-button"}
                                        disabled={this.scales[this.state.scalesIndex] === 2}
                                        onClick={() => this.scaleCanvas(this.state.scalesIndex + 1, this.props.diffCounter + 1)}>
                                        <i className="fas fa-search-plus left-icon"/>
                                        <span className='optionalLabel'>{language['powieksz']}</span>
                                    </button>
                                    <button className={!this.state.scalesIndex ? "navi-button inactive" : "navi-button"}
                                            disabled={!this.state.scalesIndex}
                                            onClick={() => this.scaleCanvas(this.state.scalesIndex - 1, this.props.diffCounter - 1)}>
                                        <span className='optionalLabel'>{language['pomniejsz']}</span>
                                        <i className="fas fa-search-minus right-icon"/>
                                    </button>
                                    <button className="navi-button" onClick={() => this.scaleCanvas(5, 0)}>100%</button>
                                </div>
                                <CustomMenu/>
                            </div>
                        </ActionsBar>
                    </div>
                }
            </LanguageContext.Consumer>
        )
    }
}

export default connect(
    state => ({
        activePuzzle: state.activePuzzle,
        puzzlesOnBoard: state.puzzlesOnBoard,
        purePuzzles: state.purePuzzles,
        sheets: state.sheets,
        isExpandedRightMenu: state.expandRightMenu,
        showClearAlertState: state.showClearAlert,
    }),
    {
        changeSinglePuzzle,
        handleDraggedPuzzles,
        updateBoard,
        showAlert,
        hideRightMenu,
        setActiveButton,
        showClearAlert,
        clearPuzzles
    }
)(WorkingSpace);



// WEBPACK FOOTER //
// ./src/WorkingSpace/WorkingSpace.js